export * from './const.js';

import Component from './component.vue';
export default Component;



// WEBPACK FOOTER //
// ./src/components/markup/popup/form/notification/index.js